import React from 'react';
import ModalBase from 'components/features/modal/Modal';

type Props = {
  isShow: boolean;
  modalBaseClass?: string;
  close?: () => void;
  closeOnClickOutsideWindow?: boolean;
};

const Modal2: React.FC<Props> = props => {
  if (!props.isShow) {
    return null;
  }

  return (
    <ModalBase
      onClose={() => {
        if (props.close) props.close();
      }}
      closeOnClickOutside={props.closeOnClickOutsideWindow}
      modalStyle={props.modalBaseClass}>
      {props.children}
    </ModalBase>
  );
};

export default Modal2;
